import React, { useState, useEffect } from 'react'
import { Text, View, TouchableOpacity, Image, ScrollView, Alert, TextInput, Linking, ActivityIndicator} from 'react-native'
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { LinearGradient } from 'expo-linear-gradient';
import { collection, query, where, getDocs, getFirestore, addDoc, doc, deleteDoc, Timestamp, orderBy} from "firebase/firestore";
import { getDownloadURL, getStorage, uploadBytes, ref } from "firebase/storage";
import  * as DocumentPicker from 'expo-document-picker';
import { getAuth } from "firebase/auth";
import { useFocusEffect } from '@react-navigation/native';
import styles from './style';



export default function CasosConcluidosDAO({ navigation }) {

    const [retorno, setRetorno] = useState([]);
    const [retorno2, setRetorno2] = useState([]);

    const [email, setEmail] = useState("");
    const [diplo, setDiplo] = useState("");
    const [cas, setCas] = useState("");
    const [open, setOpen] = useState(false);

    const [reload, setReload] = useState("");
    const [email2, setEmail2] = useState("");
    const [dataAtual, setDataAtual] = useState("")

    const auth = getAuth();
    const user = auth.currentUser;
    const [emailProf, setEmailProf]= useState("");
    const [cont, setCont] = useState(0);
    const [nome, setNome] = useState("");
    const [permissaoDAO, setPermissaoDAO] = useState("");
    const [pesquisa, setPesquisa] = useState(false);
    const [emailConsulta, setEmailConsulta] = useState("");
    const [data, setData] = useState("");
   
    const Tick =  () => {
        var data = new Date();

        var dia = String(data.getDate()).padStart(2, '0');
        var mes = String(data.getMonth() + 1).padStart(2, '0');
        var ano = data.getFullYear();
        setDataAtual(dia + '/' + mes + '/' + ano)

    }

    useEffect(() => {
        getResumos();
        setReload("");
        setOpen(false);
        setEmail(false);
        setEmail2("");
        setRetorno([])
    }, [reload])

    useFocusEffect(
        React.useCallback(() => {
            if (user !== null) {
                user.providerData.forEach((profile) => {
                    setEmailProf(profile.email)
                });
            } 

            for (var i = 0; i <= 2; i++) {
                setCont(cont + i)
            }
        }, [])
      );

      const getNome = async () => {
        for (var i = 0; i <= 2; i++) {
            const db = getFirestore();
            
            const citiesRef = collection(db, "Usuarios");
            const q = query(citiesRef, where("email", "==", emailProf));

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());
                setNome(doc.data().nome);
            });
        }
    }

    const getPermissao = async () => {
        const db = getFirestore();
            
        const citiesRef = collection(db, "Usuarios");
        const q = query(citiesRef, where("email", "==", emailProf), where("dao", "==", "Sim"));

        const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());
                setPermissaoDAO(doc.data().dao);
        });
      
    }

    useEffect(() =>{
        getNome();
        getPermissao();
    },[cont])
    
    const getResumos = async () => {

        const db = getFirestore();
        const citiesRef = collection(db, "CasosDAO");
        const q = query(citiesRef, where("status", "==", "Finalizado"));
        let array = [];

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());

            const Obj = {
                id: doc.id,
                email: doc.data().email,
                nome: doc.data().ifoUsuario.nome,
                grupo: doc.data().ifoUsuario.grupo,
                diplo: doc.data().ifoUsuario.diplo,
                status: doc.data().status,
                numeroCaso: doc.data().numeroCaso,
                Anamnesis: doc.data().Anamnesis,
                CefalometriaPaciente: doc.data().CefalometriaPaciente,
                DocPaciente: doc.data().DocPaciente,
                data: doc.data().data,
                validata: doc.data().validata,
                initData: doc.data().initData,
                Prof: doc.data().Prof,
                Planej: doc.data().Planej,
                face: doc.data().face,
                tipo: "CASO",
                consulta: doc.data().ifoUsuario,
                Envio: doc.data().Envio,
                Arquivo: doc.data().Arquivo,
                Motivo: doc.data().Motivo,
                CasoDAO: doc.data().CasoDAO,
                nomePaciente: doc.data().nomePaciente,
            };
            array.push(Obj)
        });

 
        ordenarArrayPorEnvioDiploNumeroCasoEValidata(array)
    }

    function ordenarArrayPorEnvioDiploNumeroCasoEValidata(array) {
        // Mover os elementos com diplo igual a "DAO" para o topo

        const otherElements = array.filter(item => item.diplo !== '');
    
        // Ordenar o array otherElements por Planej
        otherElements.sort((a, b) => {
            // Função para interpretar a string de Planej como uma data
            const parsePlanejDate = (initData) => {
                const [day, month, year] = initData.split('/').map(Number);
                return new Date(year, month - 1, day); // Mês em JavaScript é 0-indexed
            };
    
            // Comparar as datas de Planej
            const dateA = parsePlanejDate(a.initData);
            const dateB = parsePlanejDate(b.initData);
    
            // Comparar considerando primeiro o ano, depois o mês e por último o dia
            if (dateA.getFullYear() !== dateB.getFullYear()) {
                return dateA.getFullYear() - dateB.getFullYear();
            } else if (dateA.getMonth() !== dateB.getMonth()) {
                return dateA.getMonth() - dateB.getMonth();
            } else {
                return dateA.getDate() - dateB.getDate();
            }
        });
    
        // Combinar os arrays ordenados
        const arrayOrdenado = [...otherElements];
    
        setRetorno(arrayOrdenado);
    }
    

    const getResumos2 = async () => {

        const db = getFirestore();
        const citiesRef = collection(db, "CasosDAO");
        const q = query(citiesRef, where("email", "==", email), where("numeroCaso", "==", cas), where("validata", "==", data), where("status", "==", "Finalizado"), orderBy("email"));
        let array = [];

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());

            const Obj = {
                id: doc.id,
                email: doc.data().email,
                nome: doc.data().ifoUsuario.nome,
                grupo: doc.data().ifoUsuario.grupo,
                diplo: doc.data().ifoUsuario.diplo,
                status: doc.data().status,
                numeroCaso: doc.data().numeroCaso,
                Anamnesis: doc.data().Anamnesis,
                CefalometriaPaciente: doc.data().CefalometriaPaciente,
                DocPaciente: doc.data().DocPaciente,
                data: doc.data().data.seconds,
                validata: doc.data().validata,
                initData: doc.data().initData,
                Prof: doc.data().Prof,
                Planej: doc.data().Planej,
                face: doc.data().face,
                tipo: "CASODAO",
                consulta: doc.data().ifoUsuario,
                Envio: doc.data().Envio,
                Arquivo: doc.data().Arquivo,
                Motivo: doc.data().Motivo,
                CasoDAO: doc.data().CasoDAO,
                nomePaciente: doc.data().nomePaciente,
            };
            array.push(Obj)
        });

        setRetorno2(array)
    }


    useEffect(() => {
        getResumos();
        Tick();
    }, [nome])

    useEffect(() => {
        getResumos2();
    },[email])

    const handleKeyPress = ({ nativeEvent: { key: keyValue } }) => {
        if(keyValue === 'Enter'){  
          if(pesquisa === true){
            setPesquisa(false)
          }else{
            setPesquisa(true)
          }
        }
    };

    useEffect(() => {
        getResumos3();
    }, [pesquisa])

    const getResumos3 = async () => {

        const db = getFirestore();
        const citiesRef = collection(db, "CasosDAO");
        const q = query(citiesRef, where("email", "==", emailConsulta),  where("tipo", "==", "CASO"), where("data", "!=", null), orderBy("data"));
        const q2 = query(citiesRef, where("ifoUsuario.nome", ">=", emailConsulta), where("ifoUsuario.nome", "<=", emailConsulta + "\uf8ff"), where("tipo", "==", "CASO"));
        let array = [];

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());

            const Obj = {
                id: doc.id,
                email: doc.data().email,
                nome: doc.data().ifoUsuario.nome,
                grupo: doc.data().ifoUsuario.grupo,
                diplo: doc.data().ifoUsuario.diplo,
                status: doc.data().status,
                numeroCaso: doc.data().numeroCaso,
                Anamnesis: doc.data().Anamnesis,
                CefalometriaPaciente: doc.data().CefalometriaPaciente,
                DocPaciente: doc.data().DocPaciente,
                data: doc.data().data,
                validata: doc.data().validata,
                initData: doc.data().initData,
                Prof: doc.data().Prof,
                Planej: doc.data().Planej,
                face: doc.data().face,
                tipo: "CASO",
                Envio: doc.data().Envio,
                Arquivo: doc.data().Arquivo,
                Motivo: doc.data().Motivo,
                CasoDAO: doc.data().CasoDAO,
                nomePaciente: doc.data().nomePaciente,
            };
            array.push(Obj)
        });

        const querySnapshot2 = await getDocs(q2);
        querySnapshot2.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());

            const Obj = {
                id: doc.id,
                email: doc.data().email,
                nome: doc.data().ifoUsuario.nome,
                grupo: doc.data().ifoUsuario.grupo,
                diplo: doc.data().ifoUsuario.diplo,
                status: doc.data().status,
                numeroCaso: doc.data().numeroCaso,
                Anamnesis: doc.data().Anamnesis,
                CefalometriaPaciente: doc.data().CefalometriaPaciente,
                DocPaciente: doc.data().DocPaciente,
                data: doc.data().data,
                validata: doc.data().validata,
                initData: doc.data().initData,
                Prof: doc.data().Prof,
                Planej: doc.data().Planej,
                face: doc.data().face,
                tipo: "CASO",
                Envio: doc.data().Envio,
                Arquivo: doc.data().Arquivo,
                Motivo: doc.data().Motivo,
                CasoDAO: doc.data().CasoDAO,
                nomePaciente: doc.data().nomePaciente,
            };
            array.push(Obj)
        });

        setRetorno(array)
    }


    console.log(retorno)
    return (
        <>
            <View style={styles.container}>
                
                <View style={styles.header}>
                    {open !== true ?
                        <View>
                            <Text style={styles.Title}>Caso Clínico</Text>
                        </View>
                        :
                        <View>
                            <Text style={styles.Title}>Caso clínico do aluno</Text>
                        </View>
                    }
                    <TouchableOpacity style={styles.buttomMenu} onPress={() => navigation.goBack()} >
                        <MaterialCommunityIcons
                            name="reply"
                            size={40}
                            color="#ffffff" />
                    </TouchableOpacity>
                    {open ===  false &&
                        <TouchableOpacity style={{position: "absolute", top: 0, right: 30, marginTop: 20}} onPress={() => {getResumos()}} >
                            <MaterialCommunityIcons
                                name="refresh-circle"
                                size={50}
                                color="#ffffff" />
                        </TouchableOpacity>
                    }

                    <View style={{position: "absolute", top: 30, right: 150}}>
                        <Text style={{fontSize: 30, textAlign: 'center', color: "#FFF", fontWeight: "bold"}}>Nº Casos: {retorno.length}</Text>
                    </View>

                </View>
                

                <View style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 30, marginBottom: 30 }}>

                {open !== true ?
                    <>
                    <View style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', flexDirection: 'row' }}>
                        <TouchableOpacity style={{ backgroundColor: "transparent", borderBottomWidth: 1, borderBottomColor: "#FFFFFF70", margin: 20 }} 
                        onPress={() => navigation.navigate("FilaProfessor")}>
                            <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold" }}>Fila de espera</Text>
                        </TouchableOpacity>

                        <TouchableOpacity style={{
                            backgroundColor: "transparent", borderBottomWidth: 1.5, borderBottomColor: "#FFFFFF70", margin: 20,
                        }} onPress={() => navigation.navigate("MeusCasos")}>

                            <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold" }}>Meus casos clínicos</Text>
                        </TouchableOpacity>

                        <TouchableOpacity style={{ backgroundColor: "transparent", borderBottomWidth: 1, borderBottomColor: "#FFFFFF70", margin: 20 }}
                        onPress={() => navigation.navigate("AguardandoAluno")}>
                            <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold" }}>Aguardando Arquivos</Text>
                        </TouchableOpacity>
                        
                        <TouchableOpacity style={{
                            backgroundColor: "transparent", borderBottomWidth: 1.5, borderBottomColor: "#FFFFFF70", margin: 20,}} 
                            onPress={() => navigation.navigate("ProfConsulta")}>
                            <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold" }}>Pesquisa de Casos Clínicos</Text>
                        </TouchableOpacity>

                                            
                        <TouchableOpacity style={{
                            backgroundColor: "transparent", borderBottomWidth: 1.5, borderBottomColor: "#FFFFFF70", margin: 20,}} 
                            onPress={() => navigation.navigate("CasosConcluidosProf")}>
                            <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold" }}>Meus casos finalizados</Text>
                        </TouchableOpacity>
                    </View>

                    <View style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', flexDirection: 'row' }}>
                        <TouchableOpacity style={{
                            backgroundColor: "transparent", borderBottomWidth: 1.5, borderBottomColor: "#FFFFFF70", margin: 20,}} 
                            onPress={() => navigation.navigate("FilaProfessorDAO")}>
                            <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold" }}>Casos DAO (Fila)</Text>
                        </TouchableOpacity>
                    
                        <TouchableOpacity style={{
                            backgroundColor: "transparent", borderBottomWidth: 1.5, borderBottomColor: "#FFF", margin: 20,}}>
                            <Text style={{ color: "#FFF", fontSize: 25, fontWeight: "bold" }}>Casos DAO (Finalizados)</Text>
                        </TouchableOpacity>
                    </View>
                    </>
                    :
                    <View style={{justifyContent: 'center', alignItems: 'center', alignContent: 'center', flexDirection: 'row', marginTop: 30, marginBottom: 30}}>
                            <TouchableOpacity onPress={() => {setOpen(false), setEmail(""), setCas("")}}>
                                <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold"}}>Meus casos finalizados</Text>
                            </TouchableOpacity>
                            <Text style={{ color: "#FFFFFF70", fontSize: 25, fontWeight: "bold"}}> -{'>'} </Text>
                            <Text style={{ color: "#FFF", fontSize: 25, fontWeight: "bold"}}>Documentos Enviados</Text>
                        </View>
                    }
                </View>

                {open === true &&
                <View>
                    {retorno2 && retorno2.map((item) => {
                    return (
                        <>
                        
                            <View style={styles.divReturn}>
                                <Text style={{position: "absolute", top: 0, right: 0, marginRight: 25, marginTop: 17}}>Nº Caso Clínico: {item.numeroCaso}</Text>
                                <Text style={styles.textReturnTitle}>{item.nome}</Text>
                                <Text style={styles.textReturnEmail}>{item.email}</Text>
                                <Text style={styles.textReturnEmail2}>{item.validata}        Paciente: {item.nomePaciente}</Text>
                            </View>

                            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginBottom: 30, marginTop: 20 }}>
                                {item.Anamnesis !== "" &&
                                    <TouchableOpacity style={styles.buttonView1} onPress={() => {
                                            Linking.openURL(item.Anamnesis);
                                            }}>
                                            <Text style={styles.textView}>📄 Guía de Anamnesis</Text>
                                    </TouchableOpacity>
                                }

                                <TouchableOpacity style={styles.buttonView2} onPress={() => {
                                        Linking.openURL(item.DocPaciente);
                                        }}>
                                        <Text style={styles.textView}>📄 Documentação do Paciente</Text>
                                </TouchableOpacity>


                                {item.CefalometriaPaciente !== "" &&
                                    <TouchableOpacity style={styles.buttonView3} onPress={() => {
                                            Linking.openURL(item.CefalometriaPaciente);
                                            }}>
                                            <Text style={styles.textView}>📄 Cefalometría</Text>
                                    </TouchableOpacity>
                                }
                            </View>
                        </>
                    )
                    })}
                </View>
            }

            {open ===  false &&
                <View style={{alignSelf: "center", marginBottom: 20}}>
                    <View style={{flexDirection: 'row'}}>
                        <TextInput 
                        style={{
                            alignItems: 'center', width: 500, marginTop: 30, padding: 10,
                            height: 60, marginLeft: "auto", marginRight: "auto", color: "#000", 
                            fontSize: 17, backgroundColor: "#FFF", borderRadius: 20
                        }}
                            placeholder="E-mail ou Nome..."
                            placeholderTextColor="#000"
                            type="text"
                            onChangeText={(text) => setEmailConsulta(text)}
                            value={emailConsulta} 
                            onKeyPress={handleKeyPress}
                            />
                    

                        <TouchableOpacity style={{backgroundColor: "#5077A1", width: 60, height: 60, borderRadius: 30, marginLeft: 20, marginTop: 30}} onPress={() => pesquisa === true ? setPesquisa(false) : setPesquisa(true) }>
                            <MaterialCommunityIcons
                                name="magnify"
                                size={30}
                                color="#FFF"
                                style={{alignItems: "center", alignContent: "center", alignSelf: "center", marginTop: 13}}
                            />
                        </TouchableOpacity>
                    </View>
                </View>
            }


            <View style={{justifyContent: "center",  alignItems: "center"}}>
            <ScrollView horizontal={true} style={{flex: 1}}>
            {open ===  false &&
                <View style={{margin: 30, justifyContent: "center", alignItems: "center"}}>
                    <View style={{flexDirection: 'row',  }}>
                        <View style={{backgroundColor: "#FAEDB5", width: 400, height: 60, margin: 5, borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                            <Text style={{color: "#000", textAlign: "center", fontSize: 20, fontWeight: "bold"}}>Nome do aluno</Text>
                        </View>
                        <View style={{backgroundColor: "#FAEDB5", width: 450, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                            <Text style={{color: "#000", textAlign: "center", fontSize: 20, fontWeight: "bold"}}>Email</Text>
                        </View>
                        <View style={{backgroundColor: "#FAEDB5", width: 450, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                            <Text style={{color: "#000", textAlign: "center", fontSize: 20, fontWeight: "bold"}}>Nome do Paciente</Text>
                        </View>
                        <View style={{backgroundColor: "#FAEDB5", width: 150, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                            <Text style={{color: "#000", textAlign: "center", fontSize: 20, marginTop: 10, fontWeight: "bold"}}>Data</Text>
                        </View>
                        <View style={{backgroundColor: "#FAEDB5", width: 260, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                            <Text style={{color: "#000", textAlign: "center", fontSize: 20, fontWeight: "bold"}}>Abrir Documentos</Text>
                        </View>
                    </View>

                    {retorno && retorno.map((item) => {
                    return (
                        <>
                            <View style={{flexDirection: 'row', }}>
                                <View style={{backgroundColor: "#EDEDF4", width: 400, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                                    <Text style={{color: "#000", textAlign: "center", fontSize: 20, margin: 10, fontWeight: "bold"}}>{item.nome}</Text>
                                </View>

                                <View style={{backgroundColor: "#EDEDF4", width: 450, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                                    <Text style={{color: "#000", textAlign: "center", fontSize: 20, margin: 10, fontWeight: "bold"}}>{item.email}</Text>
                                </View>

                                <View style={{backgroundColor: "#EDEDF4", width: 450, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                                    <Text style={{color: "#000", textAlign: "center", fontSize: 20, margin: 10, fontWeight: "bold"}}>{item.nomePaciente}</Text>
                                </View>

                                <View style={{backgroundColor: "#EDEDF4", width: 150, height: 60, margin: 5,borderRadius: 15, justifyContent: "center", alignItems: "center"}}>
                                    <Text style={{color: "#000", textAlign: "center", fontSize: 20, margin: 10, fontWeight: "bold"}}>{item.initData}</Text>
                                </View>
  
                                <View style={{backgroundColor: "#5077A1", width: 260, height: 60, margin: 5, borderRadius: 15, justifyContent: "center", alignItems: "center"}}>

                                    <TouchableOpacity onPress={() => {
                                        setEmail(item.email),
                                        setCas(item.numeroCaso),
                                        setDiplo(item.diplo),
                                        setData(item.validata)
                                        setOpen(true)
                                    }}>
                                        <Text style={{color: "#fff", textAlign: "center", fontSize: 20, fontWeight: "bold"}}>Ver caso clínico</Text>
                                    </TouchableOpacity>
                                </View>

                            </View>
                        </>
                    )
                    })}
                </View>
            }
            </ScrollView>
            </View>

            </View>
        </>
    )

}